import TokenViewer from "components/views/outputs/token-viewer";

const MathematicalText = ({value}) => {
   return (
      <TokenViewer tokens={value} className="mathematical-text" />
   );
};

export default MathematicalText;
